
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 120 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_28570_44550)","fill":"currentColor"}},[_c('path',{attrs:{"d":"M101.155 19.806v9.12h2.915v-6.08h10.661v6.08h2.916v-9.12h-16.492zm2.582-2.957h11.244c1.583-.291 2.707-1.707 3.04-3.04h-17.324c.333 1.333 1.499 2.707 3.04 3.04zM92.285 28.926c1.458-.625 2.249-1.707 2.582-2.957H81.75V13.851h-2.957v15.075h13.493zM56.93 16.807H67.34c1.583-.458 2.874-1.665 3.207-2.956H54.056v8.911h13.492v3.124H56.971c-1.666.458-3.082 1.582-3.79 3.04h17.282v-9.12H56.971l-.042-2.999zm-25.653.042H42.52c1.582-.291 2.748-1.707 3.04-3.04H28.194c.334 1.333 1.5 2.707 3.082 3.04zm0 5.955H42.52c1.582-.291 2.748-1.707 3.04-3.04H28.194c.334 1.333 1.5 2.707 3.082 3.04zm0 6.122H42.52c1.582-.292 2.748-1.707 3.04-3.04H28.194c.334 1.332 1.5 2.748 3.082 3.04zM2 13.847c.333 1.333 1.5 2.666 3.04 2.999h4.748l.25.083v11.952h2.956V16.929l.25-.083h4.747c1.583-.417 2.707-1.666 3.04-2.999v-.041L2 13.847z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_28570_44550"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(2 13.8)","d":"M0 0h116.063v15.135H0z"}})])])])
          )
        }
      }
    